<div class="range-slider">
  <div class="range-slider__header">
    <label class="range-slider__label">{{ label }}</label>

    <mat-form-field appearance="outline" class="range-slider__field">
      <input
        matInput
        type="number"
        [ngModel]="value"
        [min]="min"
        [max]="max"
        [step]="step"
        (ngModelChange)="onNumberInput($event)"
        (blur)="onInputCommit()"
        (keyup.enter)="onInputCommit()"
      />
    </mat-form-field>
  </div>

  <div class="range-slider__error" *ngIf="errorMsg" role="alert">
    {{ errorMsg }}
  </div>

  <mat-slider
    class="range-slider__control"
    [class.range-slider__control--bidirectional]="min < 0 && max > 0"
    [min]="min"
    [max]="max"
    [step]="step"
    discrete
  >
    <input
      matSliderThumb
      [ngModel]="value"
      (ngModelChange)="onSliderInput($event)"
      (dragEnd)="onRelease()"
    />
  </mat-slider>

  <div class="range-slider__limits" aria-hidden="true">
    <span>{{ min }}</span>
    <span *ngIf="min < 0 && max > 0">0</span>
    <span>{{ max }}</span>
  </div>
</div>
